import { useState, useEffect, useCallback } from "react";
import getApi from "./api";
import useApiParams from "services/backend/useApiParams";

export default function useInstanceStatus() {
  const { params } = useApiParams();
  const [instance, setInstance] = useState([]);
  const [error, setError] = useState(false);

  const update = useCallback(() => {
    if (params) {
      getInstanceStatus(params)
        .then((res) => {
          setInstance(res);
        })
        .catch((err) => {
          setError(err);
        });
    }
  }, [params]);

  useEffect(() => {
    update();
  }, [update, params]);

  return { instance, update, error };
}
export function getInstanceStatus(apiParams) {
  const api = getApi(apiParams);
  return new Promise((resolve, reject) => {
    api
      .get("/getInstance")
      .then((res) => {
        if (res.error) {
          reject(res.error);
        }
        if (res.data.error) {
          reject(res.data.error);
        }
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
